var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.allChannels)?_c('WrapperFollowersByChannel',{key:_vm.keyFollowersByChannel}):_c('div',[_c('FanbaseEvolution')],1),_c('FanbaseGrowthTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }